module.exports = __webpack_public_path__ + "img/b6bf469.png";